<template>
  <div class="resources-feed__search resources-search">
    <form class="resources-search__form" @submit.prevent>
      <input
        type="text"
        v-model="searchTerm"
        class="resources-search__input"
        placeholder="Search by Keyword..."
      >
      <button
        class="resources-search__button"
        title="Search"
        @click="search()"
        @enter="search()"
      >
        <SearchIcon />
      </button>
    </form>
  </div>
</template>

<script>
import store from '../store/store';
import SearchIcon from './SearchIcon';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'rf/getField',
  mutationType: 'rf/updateField'
});

export default {
  name: 'Search',
  components: {
    SearchIcon
  },
  store: store,
  methods: {
    search () {
      store.dispatch('rf/resetFeed');
      store.dispatch('rf/returnResources');
    }
  },
  computed: {
    ...mapFields(['searchTerm'])
  }
};
</script>

<style></style>
